<template>
  <frontoffice-frame class="offline-booking-form">
    <frontoffice-loader v-if="isLoading" />

    <online-booking-hotel-availabilities v-else-if="isOnline" :duplicate="true" />

    <offline-booking-form v-else :duplicate="true" />
  </frontoffice-frame>
</template>

<script>
import frontofficeFrame from '@/components/frontoffice/frame'
import OfflineBookingForm from '@/components/frontoffice/OfflineBooking/OfflineBookingForm'
import OnlineBookingHotelAvailabilities from '@/views/frontoffice/bookings/onlineBooking/onlineBookingHotelAvailabilities'
import CommonApi from '@/api/commonApi'
import frontofficeLoader from '@/components/frontoffice/loader'

export default {
  components: {
    frontofficeFrame,
    OfflineBookingForm,
    OnlineBookingHotelAvailabilities,
    frontofficeLoader
  },

  data () {
    return {
      isLoading: true,
      commonApi: new CommonApi()
    }
  },

  created () {
    if (this.isOnline) {
      this.updateCurrentPageStore()
      this.setParams()
    } else {
      this.isLoading = false
    }
  },

  beforeRouteLeave (to, from, next) {
    this.updateCurrentPageStore(false)
    next()
  },

  methods: {
    /**
     * required in case of page refresh so as not to be redirected to offline duplicate
     * @param enter (boolean)
     */
    updateCurrentPageStore (enter = true) {
      this.$store.commit('currentPage/onlineDuplicate', enter)
    },

    setParams () {
      this.commonApi.searchBooking(this.$route.params.id)
        .then( response => {
          let booking = response.data.data.booking
          this.$store.commit('research/destination', this.getDestination(booking))
          this.$store.commit('research/favorite', this.getFavorite(booking))
          this.$store.commit('research/bedrooms', this.getRooms(booking))
        })
        .then (() => {
          this.isLoading = false
        })
    },

    getDestination (booking) {
      let locationName =
          booking.hotel_city_text ? booking.hotel_city_text
        : booking.hotel ? booking.hotel.city
        : booking.desired_city ? booking.desired_city
        : null

      return locationName ? { locationName : locationName } : null
    },

    getFavorite (booking) {
      return {
        location: booking.desired_location || null, // FIXME
        hotel: booking.hotel || booking.desired_hotel || null // FIXME
      }
    },

    getRooms (booking) {
      let rooms = {
        single: {
          amount: booking.single_rooms,
          travellers: []
        },
        double: {
          amount: booking.double_rooms,
          travellers: [],
          bedType: null
        }
      }

      let i = {
        single: 0,
        double: 0
      }

      for (let room of Object.values(booking.hotel_rooms)) {
        let travellers = {
          1: room._traveller1
        }

        if (room.type === 'double') {
          travellers[2] = room._traveller2
          rooms[room.type].bedType = room.bed_type
        }

        rooms[room.type].travellers.push(travellers)
      }

      return rooms
    }
  },

  computed: {
    isOnline () {
      return this.$store.state.currentPage.onlineDuplicate || this.$route.params.isOnline
    }
  }
}
</script>
